import { supabase } from "@/integrations/supabase/client";
import {
  buildNotificationPreferenceRecord,
  notificationPreferenceColumns,
  type NotificationPreferenceKey,
  type NotificationPreferenceRecord,
} from "../../shared/system";

const notificationPreferenceSelect = notificationPreferenceColumns.join(", ");

export interface DispatchNotificationInput {
  userId: string;
  type: string;
  body: string;
  entityType: string;
  entityId: string;
  title?: string;
  url?: string;
}

export const fetchNotificationPreferences = async (
  userId: string,
): Promise<NotificationPreferenceRecord> => {
  const { data, error } = await supabase
    .from("notification_preferences")
    .select(notificationPreferenceSelect)
    .eq("user_id", userId)
    .maybeSingle();

  if (error) {
    console.warn("Could not load notification preferences", error);
    return buildNotificationPreferenceRecord();
  }

  return buildNotificationPreferenceRecord(
    (data ?? null) as Partial<Record<NotificationPreferenceKey, boolean>> | null,
  );
};

export const saveNotificationPreferences = async (
  userId: string,
  patch: Partial<NotificationPreferenceRecord>,
) => {
  const { data, error } = await supabase
    .from("notification_preferences")
    .upsert(
      {
        user_id: userId,
        ...patch,
      },
      { onConflict: "user_id", ignoreDuplicates: false },
    )
    .select(notificationPreferenceSelect)
    .single();

  return {
    data: data
      ? buildNotificationPreferenceRecord(
          data as Partial<Record<NotificationPreferenceKey, boolean>>,
        )
      : null,
    error,
  };
};

export const createNotificationIfEnabled = async ({
  userId,
  type,
  body,
  entityType,
  entityId,
}: DispatchNotificationInput) =>
  supabase.rpc("create_notification_if_enabled", {
    target_user_id: userId,
    notification_type: type,
    notification_entity_type: entityType,
    notification_entity_id: entityId,
    notification_body: body,
  });
